import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { Sparkle } from "@/components/Sparkle";

export const JujuModal = ({ open, onClose, title, message, popupTestId, messageTestId, children }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-no-roll
        className="fixed inset-0 z-[80] flex items-center justify-center px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="absolute inset-0 bg-[#0B2447]/35 backdrop-blur-md" onClick={onClose} />
        <motion.div
          data-testid={popupTestId}
          className="glass relative w-full max-w-md overflow-hidden rounded-3xl p-10 text-center shadow-2xl"
          initial={{ scale: 0.7, y: 40, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.85, y: 20, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 22 }}
        >
          <Sparkle className="sparkle absolute left-8 top-6 h-6 w-6 text-[#2E5BFF]" />
          <Sparkle className="sparkle absolute bottom-8 right-8 h-4 w-4 text-[#7FB2FF]" style={{ animationDelay: "0.8s" }} />
          <Sparkle className="sparkle absolute right-12 top-10 h-3 w-3 text-[#2E5BFF]" style={{ animationDelay: "1.4s" }} />
          <button
            data-testid="juju-modal-close-btn"
            onClick={onClose}
            className="absolute right-4 top-4 text-white/70 transition-colors hover:text-white"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          {title && (
            <p className="mb-4 text-xs uppercase tracking-[0.3em] text-white/80">{title}</p>
          )}
          <p data-testid={messageTestId} className="juju-heading text-xs leading-relaxed sm:text-sm">
            {message}
          </p>
          {children}
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
